module.exports = __webpack_public_path__ + "static/media/marketing.e03228af.svg";